export let textos = [
  {
    menu: {
      inicio: 'Início',
      tradicao: 'A Tradição',
      oesporte: 'O Esporte',
      equipamentos: 'Equipamentos',
      aarena: 'A Arena',
      osatletas: 'Os Atletas',
      osanimais: 'Os Animais',
      fotos: 'Fotos',
      localizacao: 'Localização',
      contato: 'Contato',
      imprensa: 'Imprensa',
    },
    titulo: 'Corrida de Quadrigas',
    frase:
      "Um esporte milenar que foi extinto no Século IV D.C. e ressurge como esporte, pela primeira vez, na Fazenda Estrela D'Oeste em São Simão, no Interior de São Paulo. Confira este maravilhoso esporte, sua segurança e tradição.",
    pdf: `As Quadrigas em Arenas Brasileiras`,
    linkPdf: `Clique para ler`,
    arquivo: `pt_as_quadrigas_em_arena_brasileira.pdf`,
    imprensa: {
      titulo: `Sala de Imprensa`,
      texto: 'Veja o que já foi noticiado sobre as Corridas de Quadrigas'
    },
    tradicao: {
      titulo: 'A Tradição',
      texto: `<p>A quadriga (Latin quadri-, quatro, e jungere, juntas) é um carro ou carroça conduzida por quatro cavalos lado à lado.</p>
      <p>A quadriga foi inventada pelos Assírios que rapidamente as transformaram em carros de guerra.</p>
      <p>Através dos tempos foram assimilados por outros povos e incorporados aos seus exércitos.</p>
      <p>Os romanos enfim, popularizaram as Corridas de Quadrigas como esporte. A quadriga foi adotada na Roma antiga nas corridas de carruagens, sendo o Circo Máximos de Roma palco de muitas delas.</p>
      <p>Nesta época, ao contrário do que acontece hoje, pouco se preocupava com a integridade física dos participantes.</p>
      <p>Suas corridas reuniam multidões de espectadores e eram assistidas por todas as classes sociais, da plebe ao Imperador.</p>
      <p>A Corrida de Quadrigas Romanas teve sua extinção em 400 D.C.</p>`,
    },

    oesporte: {
      titulo: 'O Esporte',
      texto: `<p>A Corrida de Quadrigas que praticamos atualmente é da mesma forma que era praticada na Roma antiga porém, buscando o desenvolvimento do esporte, valoriza-se acima de tudo preservar a integridade física dos participantes.</p>
        <p>Os treinamentos são GRATUITOS e oferecidos a quem queira praticar o esporte e acontecem de forma gradativa tanto para os cavalos quanto para os ginetes iniciantes. São necessárias 3 sessões por semana com duração de 30 minutos cada sessão, por um período de 4 meses. Desde o primeiro momento o iniciante trabalha com as rédeas nas mãos e um ginete experiente ao lado para dar-lhe orientação e segurança. Tanto cavalos como ginetes precisam no mínimo 3 sessões por semana e nos treinamentos os cavalos utilizam apenas 30% de sua força.</p>
        <p>A Corrida de Quadrigas é um esporte dos mais democráticos pois podem participar pessoas de ambos os sexos, com idade entre 18 e 70 anos. A única exigência, como em qualquer outro esporte, é dedicação e treinamento. Atualmente corremos entre nossa equipe disputando contra o relógio, mas, com o aumento dos participantes, em breve estaremos disputando este esporte em formato de campeonatos de Corrida de Quadrigas.</p>
        <p>As provas são executadas com até 9 carros em cada bateria. O rito dentro da arena consiste numa apresentação em coluna horizontal que permite ter noção da força das quadrigas. Em seguida faz-se a largada e corre-se por 7 voltas no circuito oval anti-horário perfazendo aproximadamente 3.200 metros de percurso, que são cobertos em 4 minutos e meio.</p>
        <p>A velocidade máxima alcançada por um conjunto é aproximadamente 60km/h. Os carros atualmente são feitos de alumínio, para que sejam leves e resistentes oferecendo sempre segurança para a prática do esporte, seja para os cavalos e para os ginetes. Os arreios e rédeas que utilizamos atualmente foram copiados na íntegra do Épico Ben Hur, que foi um filme onde ouve uma pesquisa histórica imensa para sua produção.</p>
        <p>As solas de tração devem ser reforçadas com tramas de nylon embutidas. Nada impede que também os arreios sejam feitos em outro material. Hoje, com nossa disponibilidade de matéria prima esperamos mais iniciativas em termos de arreios.</p>
        <p>As rédeas podem ser de couro ou de tecido, revestidas em vaqueta na altura das argolas.</p>
        <h5>Procedimentos de segurança:</h5>
        <p>Temos poucas porém fundamentais regras de segurança. Se cumpridas, garantimos a sua eficácia. São elas:</p>
        <p>1. Nenhum ginete deve correr exatamente atrás do ginete a sua frente, próximo demais do seu carro na mesma trajetória.</p>
        <p>2. Os ginetes devem olhar para trás no mínimo duas vezes em cada reta do circuito oval, no início e próximo ao final de cada uma delas. Deve olhar para trás para certificar-se da posição dos demais carros em relação ao seu. Caso haja um carro correndo atrás do seu, muito próximo durante a trajetória da reta e o carro de trás não tirou do alinhamento da sua traseira, o ginete da frente tira o seu carro da frente pois o carro de trás pode estar com algum problema.
        Importante também dar a preferência para aquele que a tiver, nas entradas de curvas.</p>`,
    },

    equipamentos: {
      titulo: 'Equipamentos',
      itens: [
        {
          titulo: 'Lombilho',
          img: 'lombilho',
          texto: `Permite a frenagem do carro. Com 02 (duas) alças laterais que suportam as sola de tração (apoio da frenagem se dá na cernelha).`,
        },
        {
          titulo: 'Peiteira',
          img: 'peiteira',
          texto: `Apoio no peito e pescoço do animal para imprimir força.`,
        },
        {
          titulo: 'Rabicho de Peiteira',
          img: 'rabicho',
          texto: `Acessório que liga a peiteira ao lombilho. Transmiti força de frenagem
          para o lombilho.`,
        },
        {
          titulo: 'Bridão',
          img: 'bridao',
          texto: `É a embocadura do animal.`,
        },
        {
          titulo: 'Cabeçada',
          img: 'cabecada',
          texto: `Apoiar bridão e rédeas na cabeça do animal.`,
        },
        {
          titulo: 'Mangote de tração',
          img: 'mangote',
          texto: `Solas reforçadas com fivelas presas em carretéis fixados no tronco de tração para receber as solas da peiteira.`,
        },
        {
          titulo: 'Trela de peito',
          img: 'trela',
          texto: `Acessório (corrente) com 02 (dois) mosquetões (01 em cada extremidade) utilizada para prender o animal pela argola da peiteira até o anel giratório da ponta da lança.`,
        },
        {
          titulo: 'Rédea',
          img: 'redea',
          texto: ` Acessório preso aos bridões vindo até as mãos do condutor. Usado para conduzir o animal.`,
        },
        {
          titulo: 'Trela boca a boca',
          img: 'trelab',
          texto: `Limita a distância que os cavalos possuem entre si. É presa nos bridões.`,
        },
        {
          titulo: 'Sola de regulagem da peiteira',
          img: 'sola',
          texto: `Acessório com furos nas 02 (duas) extremidades. Servem para ajustar a peiteira do animal.`,
        },
      ],
    },
    aarena: {
      titulo: 'A Arena',
      texto: `<p>A arena para a prática da Corrida de Quadrigas tem uma coluna dorsal com 205 metros de comprimento por 6 metros de largura. A faixa de correr, ao redor do canteiro tem 50 metros de largura.</p>
      <p>Essas medidas vieram de um livro sobre Roma onde aprendemos que várias medidas eram adotadas em circos para a prática deste esporte. Acreditamos que esta seja a menor delas. Apenas a título de curiosidade, O Circo Máximos no coração de Roma, tem um canteiro central acima de 300 metros.</p>
      <p>A arena é concebida desta maneira por ser específica para esta categoria de atrelagem. Como tração de velocidade que é, utiliza as retas para abrir velocidade e é necessário conter a velocidade para as curvas.</p>
      <p>Nas pistas, como procedimento de segurança, as cabeceiras da arena (externa das curvas) são protegidas com material reforçado para garantir que, caso algum conjunto se choque com a cerca delimitadora da arena, ele não saia dela, e ao mesmo tempo ofereça segurança para os ginetes, os cavalos e expectadores.</p>`,
    },
    osatletas: {
      titulo: 'Os Atletas',
      texto: `<p>Mais de 25 pessoas já passaram pelo treinamento e são aptos a praticar o esporte com segurança e a ensinar este esporte para outras pessoas. Oferecemos estrutura completa para treinamento de ginetes.</p>
      <p>Quanto mais adeptos do esporte mais rápido será tornar popular a Corrida de Quadrigas.</p>`,
    },
    osanimais: {
      titulo: 'Os Animais',
      texto: `<p>Atualmente estamos com 44 cavalos para a prática deste esporte.</p>
      <p>Todos estes animais recebem um tratamento específico para animais de corrida.</p>
      <p>Ferrageamento a cada 30 dias, preparo de crina e rabo e são arraçoados e tem suplementação alimentar com orientação nutricional profissional para cavalos submetidos a exercícios pesados. Também controle parasitário.</p>
      <p>Sua rotina de treino é 3 vezes por semana, 30 minutos. Exercícios de manobras e de força que os preparam para as provas.</p>`,
    },
    fotos: {
      titulo: 'Galeria de Imagens',
    },

    contato: {
      titulo: 'Contato',
      localizacao: `Localização`,
    },
  },
  {
    menu: {
      inicio: 'Home',
      tradicao: 'Tradition',
      oesporte: 'About the sport',
      equipamentos: 'Equipament',
      aarena: 'The Arena',
      osatletas: 'Athletes',
      osanimais: 'Animals',
      fotos: 'Pictures',
      localizacao: 'Location',
      contato: 'Contact',
      imprensa: 'Press',
    },
    titulo: 'Quadrigas race',
    frase:
      'A millennial sport that was extinct on the 4th Century AD, and for the first time, rises again at Estrela D’Oeste’s farm, in São Simão, countryside of São Paulo. Learn more about this wonderful sport, its safety and tradition.',
    pdf: `The Quadrigas Arena in Brazil`,
    linkPdf: `Click to read`,
    arquivo: `en_the_quadrigas_arena_in_brazil.pdf`,
    imprensa: {
      titulo: `Press room`,
      texto: 'See what has already been reported about the Quadriga Races'
    },
    tradicao: {
      titulo: 'Tradition',
      texto: `<p>The <strong>quadriga</strong> (Latin <em>quadri</em>-, four, and <em>jiugum</em>, yoke ) is a car or chariot drawn by four horses abreast.</p>
      <p>The Quadriga was invented by the Assyrians who soon turned them into war chariots. </p>
      <p>Throughout time, other people assimilated and incorporated them to their armies.</p>
      <p>The Roman people then, turned the Quadrigas race into a sport. The Quadriga was adopted in the ancient Roman chariot racing, being the Circus Maximus in Rome, stage for many of them. </p>
      <p>At that time, on the contrary to what happens today, little they were worried about the physical integrity of their participants. </p>
      <p>The races attracted crowds of spectators and were watched by all social groups, from the common people to the Emperor.  </p>
      <p>The Roman Quadrigas race were extinct in 400 AD.</p>`,
    },

    oesporte: {
      titulo: 'About the sport',
      texto: `<p>The Quadrigas race we know today is the same as the one in ancient Rome; however, seeking the development of the sport, 
      it is valued above all, the maintenance of the physical integrity of the participants</p>
      <p>The trainings are <strong>FREE</strong> and available to whoever wants to practice the sport. They happen gradually both for the horses 
      and the novice riders. It is necessary 3 sessions a week, lasting 30 minutes each session, for a period of 4 months. From the first moment the 
      novices work with the reins in their hands side by side with a skillful rider in order to give orientation and also for ones safety. Both the horses 
      and the riders need at least three sessions a week, and during training, the horses use only 30% of their strength. </p>
      <p>The Quadrigas race is one of the most democratic sports, for people of both genders are allowed to take part, having them between 18 and 70 years. 
      The only requirement, as in any other sport, is dedication and training. Nowadays, the races are against our own team and also against the clock. 
      However, should the number of participants increase; we will soon have them by the format of the original Quadrigas race.  </p>
      <p>The events are held with up to 9 chariots in each battery. The ritual inside the arena consists of a presentation in a horizontal column which allows 
      us to have an idea of the strength of the chariots. Then, it’s given the start and the participants run 7 laps in an oval circuit in counterclockwise, 
      in a nearly 3 200 meters way, which is run in four minutes and a half. </p>
      <p>The maximum speed reached by a group is about 37 mph. The chariots nowadays are made of aluminium, so that they are light and strong in order to always
      offer safety to the practice of the sport, both for the horses and the riders. The harness and reins we use were reproduced in full from the epic Ben Hur, 
      a movie we used to make a deep historical research for their production.  </p>
      <p>The traction soles must be enhanced with nylon inline frames. There is no problem if the harnesses are also made of other materials. Today, 
      with our availability of raw material, we are expecting more initiatives, concerning the reins.  </p>
      <p>The reins can be made of leather or other material, given that they are coated with soft leather at the height of the rings. </p>
      <p><strong>Safety Procedures:</strong></p>
      <p>There are few but fundamental safety rules. If followed, we guarantee its accuracy. They are:</p>
      <p>1. No rider is allowed to run right behind the rider in front, too close to his chariot in the same way.</p>
      <p>2. The riders must look back at least twice in each line of the oval circuit, at the beginning and next to the end of each 
      one of them. Must look back to make sure the position of other chariots related to his. In case there is a chariot running too
      close to his in the line, and the chariot behind him did not remove from the alignment of his back, the rider in front must take 
      his chariot out of the way, for the chariot behind might be having some trouble.</p>
      <p>It’s also important to give preference to the entrance of curves. </p>`,
    },

    equipamentos: {
      titulo: 'Equipment',
      itens: [
        {
          titulo: 'Lombilho',
          img: 'lombilho',
          texto: `Allows the braking of the car. With two (02) side handles that support the soles of traction (supporting braking occurs in sernelha).`,
        },
        {
          titulo: 'Peiteira',
          img: 'peiteira',
          texto: `Support the chest and neck of the animal print to strength.`,
        },
        {
          titulo: 'Pigtail peiteira',
          img: 'rabicho',
          texto: `Accessory linking to peiteira lombilho. Transmit braking force to lombilho.`,
        },
        {
          titulo: 'Snaffle',
          img: 'bridao',
          texto: `And the mouth of the animal.`,
        },
        {
          titulo: 'Halter',
          img: 'cabecada',
          texto: `Support bridle and reins on the animal's head.`,
        },
        {
          titulo: 'Pinch traction',
          img: 'mangote',
          texto: `Solas reinforced buckles prey on spools fixed in the trunk to get traction soles peiteira.`,
        },
        {
          titulo: 'Leash chest',
          img: 'trela',
          texto: `Accessory (current) with 02 (two) Mosquitoes (01 at each end) used to hold the animal by the ring peiteira to the rotating ring of the tip of the spear.`,
        },
        {
          titulo: 'Reins',
          img: 'redea',
          texto: `Accessory attached to bridles come into the hands of the driver. Used to drive the animal.`,
        },
        {
          titulo: 'Leash word of mouth',
          img: 'trelab',
          texto: `Limits the distance that horses have with each other. And prey on bridles`,
        },
        {
          titulo: 'Sola-regulating peiteira',
          img: 'sola',
          texto: `Accessory with holes in two (02) ends. Serve to adjust the animal peiteira`,
        },
      ],
    },
    aarena: {
      titulo: 'The Arena',
      texto: `<p>The arena for the practice of the Quadrigas race has a spine chord of 672 feet long by 19 feet wide. The track running around the building site is 164 feet wide. </p>
      <p>These measures are from a book about Rome, where we learned that many measures were adopted in circuses for the practice of this sport. We believe that these are 
      the smallest of the measures. Just out of curiosity, the Circus Maximus in the heart of Rome has a central plot above 984 feet</p>
      <p>The arena is designed like this as it is specific for this type of coupling. As a speed traction sport, it’s important to use the lines to speed up and it’s necessary to contain the speed in the curves. </p>
      <p>On tracks, as a security procedure, the headwaters of the arena (outer curves) are protected with a reinforced material to make sure that, in case a group bump into the bounding fences of the arena, 
      the group does not get out of there and at the same time offer security to the riders, horses and also the spectators. </p>`,
    },
    osatletas: {
      titulo: 'Athletes',
      texto: `<p>More then 25 people have already undergone training and are able to practice the sport safely and also to teach it to other people. We offer complete structure for training riders.</p>
      <p>The more supporters of the sport, the quicker the Quadrigas race will become popular.</p>`,
    },
    osanimais: {
      titulo: 'Animals',
      texto: `<p>Currently, we have 44 horses to practice the sport.</p>
      <p>All of these animals have received a specific treatment for racing animals.</p>
      <p>Shoeing every 30 days and also preparation of mane and tail. They are hand fed and for the ones undergoing heavy training there is a supplemental 
      feeding with a nutritional counseling professional for horses. There is also parasite control. </p>
      <p>Their training routine is 3 times a week, for about 30 minutes. Strength and skill exercises prepare them for the races.</p>
      `,
    },
    fotos: {
      titulo: 'Pictures',
    },

    contato: {
      titulo: 'Contact',
      localizacao: `Location`,
    },
  },
  {
    menu: {
      inicio: 'Commencer',
      tradicao: 'La Tradition',
      oesporte: 'Le Sport',
      equipamentos: 'Équipement',
      aarena: 'L’Arène',
      osatletas: 'Les Athlètes',
      osanimais: 'Les Animaux',
      fotos: 'Images',
      localizacao: 'Emplacement',
      contato: 'Contact',
      imprensa: 'Presse',
    },
    titulo: 'Course de Chars',
    frase:
      "Un sport ancestral qui a été éteint au IVème siècle après JC et réapparaît comme un sport, pour la première fois, dans ferme Estrela D'Oeste à São Simão, état de São Paulo. Découvrez ce sport merveilleux, sa sécurité et sa tradition.",
    pdf: `La course de char en Arene Brasilienne`,
    linkPdf: `Cliquez pour lire`,
    arquivo: `fr_la_course_de_chars_en_arene_bresilienne.pdf`,
    imprensa: {
      titulo: `Salle de presse`,
      texto: 'Voir ce qui a déjà été rapporté sur les Quadriga Races'
    },
    tradicao: {
      titulo: 'La Tradition',
      texto: `<p>La <strong>Course de Chars (Quadrige) </strong> (Latin <em>quadri</em>- quatro, et<em>jjungere,</em> ensemble)  est une voiture ou un chariot à quatre chevaux, côte à côte.</p>
      <p>Le char a été inventé par les Assyriens, qui ont rapidement les transformée en chars pour la guerre.</p>
      <p>Au fil du temps ont été assimilées par les autres peuples et leur intégration dans leurs armées.</p>
      <p>Les Romains, finalement, ont popularisé la course de chars comme un sport. Le quadrige a été adopté dans 
      la Rome antique aux courses, et Le Cirque Maximum Rome c’est où beaucoup de ces courses ont eu lieu.</p>
      <p>A cette époque, contrairement à ce qui se passe aujourd'hui, l'intégrité physique des participants avaient peu d'importance.</p>
      <p>Ses courses rassemblés une foule de spectateurs et a été suivi par toutes les classes sociales, des plébéiens à l'Empereur.</p>
      <p>La course de chars romains a eu son extinction en 400 après JC.</p>	`,
    },

    oesporte: {
      titulo: 'Le Sport',
      texto: `<p>La Course de Chars que nous pratiquons aujourd'hui est le même que celui pratiqué dans la Rome antique, cependant, 
      en cherchant le développement du sport, c’est très important, avant tout, de préserver l'intégrité physique des participants.</p>
      <p>Les entraînements sont <strong>gratuits</strong> et offerts à tous ceux qui veulent jouer le jeu et sont organisés de manière
      progressive pour les cavaliers et pour les débutants. Il faut 3 séances de 30 minutes par semaine pour une période de quatre mois. 
      A partir du premier jour le débutant travaille avec les rênes et un cavalier expérimenté à côté pour vous donner des conseils et de 
      la sécurité. Les chevaux et les cavaliers ont besoin d'un minimum de 3 séances par semaine et dans l'entraînement des chevaux utilisent seulement 30% de sa force.</p>
      <p>La course de chars est l'un des sports les plus démocratiques, parce que personnes des deux sexes, âgés entre 18 et 70 ans peuvent participer. La seule exigence, 
      comme dans tous autres sports, est le dévouement et la formation. Actuellement, nous courons avec notre équipe en jouant contre la montre, mais avec l'augmentation
      des participants, nous allons bientôt pratiquer ce sport comme championnats.</p>
      <p>Les courses sont effectuées avec un maximum de 9 voitures dans chaque course. Le rite à l'intérieur de l'arène est d’une colonne horizontale qui donne une idée 
      de la force du char. Puis c'est le début et il fonctionne depuis sept tours dans le circuit ovale dans le sens antihoraire un total d'environ 3.200 mètres de long, 
      qui sont couverts en 4 minutes et demie.</p>
      <p>La vitesse maximale atteinte par un ensemble est d'environ 60km / h. Les voitures sont actuellement en aluminium, elles sont légères et résistantes, alors elles offrent
      toujours la sécurité pour pratiquer le sport, que ce soit pour les chevaux ou les cavaliers. Les selles et les rênes que nous utilisons aujourd'hui ont été copiées dans 
      leur intégralité de l'épopée de Ben Hur, un film où les personnes ont fait une recherche historique énorme pour sa production.</p>
      <p>Semelles pour la traction devraient être renforcées avec les cadres en nylon. Rien n'empêche les harnais d’être également produits d'autres choses. Aujourd'hui, 
      avec notre disponibilité des matières premières nous attendons des initiatives quand on parle d’harnais.</p>
      <p>Les rênes peuvent être en cuir ou en tissu, enduit en « vaqueta » dans des anneaux.</p>
      <p><strong>Procédures de sécurité:</strong></p>
      <p>Nous avons des règles de sécurité. Si elles sont satisfaites, nous garantissons leur efficacité. Ils sont les suivants:</p>
      <p>1. Aucun coureur ne doit courir derrière le coureur à l'avant, trop près de votre voiture dans la même trajectoire.</p>
      <p>2. Les coureurs doivent regarder en arrière au moins deux fois dans chaque ligne de la piste ovale au début et vers la fin de chacune. Ils doivent regarder en arrière 
      pour s'assurer de la position des autres voitures par rapport à la sienne. S’il ya une voiture derrière vous, très proche au cours de la ligne et la voiture derrière n'a pas 
      obtenu l'alignement de votre arrière, le coureur devant tire sa voiture du chemin parce que la voiture derrière peut avoir un problème</p>
      <p>C’est important aussi de donner la préférence à celui qui l’a, à l'entrée des courbes.</p>
      `,
    },

    equipamentos: {
      titulo: 'Équipement',
      itens: [
        {
          titulo: 'Lombilho',
          img: 'lombilho',
          texto: `Permet le freinage de la voiture. Avec deux (02) poignées latérales qui prennent en charge les semelles de traction (soutien freinage se produit dans sernelha)`,
        },
        {
          titulo: 'Peiteira',
          img: 'peiteira',
          texto: `Soutenir la poitrine et le cou de l'animal print à la force`,
        },
        {
          titulo: 'Pigtail peiteira',
          img: 'rabicho',
          texto: `Accessoire reliant à peiteira lombilho. Transmettre la force de freinage à lombilho`,
        },
        {
          titulo: 'Filet',
          img: 'bridao',
          texto: `Et la bouche de l'animal`,
        },
        {
          titulo: 'Halter',
          img: 'cabecada',
          texto: `Support bride et les rênes sur la tête de l'animal`,
        },
        {
          titulo: 'Traction Pinch',
          img: 'mangote',
          texto: `Solas renforcés boucles s'attaquent aux bobines fixées dans le coffre pour obtenir la traction des semelles peiteira`,
        },
        {
          titulo: 'Laisse poitrine',
          img: 'trela',
          texto: `Accessoire (actuel) avec deux (02) Moustiques (01 à chaque extrémité) utilisé pour maintenir l'animal par l'anneau peiteira à la bague tournante de la pointe de la lance`,
        },
        {
          titulo: 'Reins',
          img: 'redea',
          texto: `Accessoire fixé à brides viennent dans les mains du conducteur. Utilisé pour conduire l'animal`,
        },
        {
          titulo: 'Laisse mot de la bouche',
          img: 'trelab',
          texto: `Limite la distance que les chevaux ont les uns avec les autres. Et proie à brides`,
        },
        {
          titulo: 'Sola-régulation peiteira',
          img: 'sola',
          texto: `Accessoires avec des trous dans deux (02) extrémités. Servir à régler le peiteira animaux`,
        },
      ],
    },
    aarena: {
      titulo: 'L’Arène',
      texto: `<p>L'arène pour pratiquer de la course de chars a une épine dorsale avec plus de 205 mètres de long et 
      6 mètres de large. La piste d'athlétisme autour du chantier est de 50 mètres de large.</p>
      <p>Ces mesures sont adoptées à partir d'un livre sur Rome, où nous avons appris que plusieurs mesures ont été adoptées 
      dans les cirques pour pratiquer ce sport. Nous pensons que c'est la plus petite d'entre elles. Juste par curiosité, 
      le Cirque Maxime, au cœur de Rome, a un jardin central au dessus de 300 mètres.</p>
      <p>L'arène est conçu de cette manière parce qu’elle est spécifique pour ce type de couplage. Elle est une traction de vitesse, 
      alors elle utilise les lignes pour gagner de vitesse et il faut la contenir dans les courbes.</p>
      <p>Sur les voies, comme procédure de sécurité, le cours supérieur de l'arène (courbes extérieures) sont protégées par un matériel
      renforcé afin d'assurer que, si un char frappe avec la clôture délimitant l'arène, il ne la quitte pas, tout en assurant 
      la sécurité des cavaliers, des chevaux et des spectateurs. </p>`,
    },
    osatletas: {
      titulo: 'Les Athlètes',
      texto: `<p>Plus de 25 personnes sont venus à l’entraînement et ils peuvent pratiquer ce sport avec toute sécurité et ils peuvent aussi enseigner ce sport à d'autres. Nous offrons structure complète pour l’entraînement des coureurs.</p>
     <p>Si nous pouvons augmenter le nombre de coureurs, la popularité du sport augmente aussi.</p>`,
    },
    osanimais: {
      titulo: 'Les Animaux',
      texto: `<p>Actuellement, nous disposons de 44 chevaux pour ce sport. </p>
      <p>Tous ces animaux reçoivent un traitement spécifique pour les animaux qui courent.</p>
      <p>Maréchalerie chaque 30 jours, préparation de la crinière et la queue, et ils sont nourris par un professionnel en nutrition pour 
      les chevaux qui font de l'exercice intense. Et aussi le contrôle des parasites.</p>
      <p>Sa routine d'entraînement est de trois fois par semaine, 30 minutes. Exercices et exercices de musculation qui les préparent pour les examens.</p>
      
      `,
    },
    fotos: {
      titulo: 'Images',
    },

    contato: {
      titulo: 'Contact',
      localizacao: `Emplacement`,
    },
  },
  {
    menu: {
      inicio: 'Inizio',
      tradicao: 'La tradizione',
      oesporte: 'Lo Sport',
      equipamentos: 'Attrezzature',
      aarena: 'L`Arena',
      osatletas: 'Gli Atleti',
      osanimais: 'Gli animali',
      fotos: 'Immagini',
      localizacao: 'Posizione',
      contato: 'Contatto',
      imprensa: 'Premere',
    },
    titulo: 'Corsa delle Quadrighe',
    frase:
      "Uno sport millenario che si é estinto nel IV secolo d.C. e rinasce come sport, per la prima volta, nella Fazenda Estrela D'Oeste a São Simão, nello Stato di São Paulo. Dai un'occhiata a questo bellissimo sport, alla sua sicurezza e alla sua tradizione.",
    pdf: `Le quadrighe nell’ arena brasiliana`,
    linkPdf: `Clicca per leggere`,
    arquivo: `it_le_quadrighe_nell_arena_brasiliana.pdf`,
    imprensa: {
      titulo: `Sala stampa`,
      texto: 'Guarda quanto già riportato sulle Corse della Quadriga'
    },
    tradicao: {
      titulo: 'La Tradizione',
      texto: `<p>La <strong>quadriga</strong> (dal Latino <em>quadri- </em>-quattro e <em>jungere</em>, insieme) è un carro o carrozza trainato da quattro cavalli affiancati.</p>
      <p>La quadriga è stata inventata dagli Assiri, che ben presto la trasformarono in carro da guerra.</p>
      <p>Con il passare del tempo sono state assimilate da altri popoli e inserite nei loro eserciti.</p>
      <p>I Romani, infine resero popolari le Corse delle Quadrighe come sport. La quadriga fu adottata nella Roma antica alle corse di carro, e il Circo Massimo di Roma ne fu il principale palco.</p>
      <p>In questo epoca, a differenza di quanto accade oggi, poca era l\`importanza data all'integrità fisica dei partecipanti.</p>
      <p>Queste corse riunivano folle di spettatori ed erano seguite da tutte le classi sociali, dalla plebe all'imperatore.</p>
      <p>La Corsa delle Quadrighe Romane si estinse nel 400 d.C.</p>`,
    },

    oesporte: {
      titulo: 'Lo Sport',
      texto: `<p>La corsa delle Quadrighe che pratichiamo oggi è la stessa di quella praticata nella Roma antica, tuttavia, puntando allo 
      sviluppo di questo sport, prima di tutto, mettiamo in primo piano l'integrità fisica dei partecipanti.</p>
      <p>Gli allenamenti sono <strong>GRATUITI</strong> e offerti a chi vuole praticare questo sport. Avvengono gradualmente per entrambi, 
      tanto per i cavalli che per i piloti principianti. Sono necessarie 3 sedute settimanali della durata di 30 minuti ciascuna per un periodo 
      di quattro mesi. Fim dal primo momento il principiante lavora con le redini	in mano e un pilota esperto al fianco per ofrirgli guida e 
      sicurezza. Entrambi, cavalli e piloti, hanno bisogno di un minimo di 3 sedute a settimana e negli allenamenti i cavalli utilizzando solo 
      il 30% della loro forza.</p>
      <p>La Corsa delle Quadrighe è uno degli sport più democratici poiché possono partecipare  individui di entrambi i sessi, di età compresa
      tra i 18 e i 70 anni. L'unico requisito, come in ogni altro sport, è la dedizione e l\`esercizio. Attualmente disputiamo le corse con i partecipanti
      della nostra squadra, correndo contro il tempo, ma con l'aumento dei partecipanti, in breve potremo disputare le corse in forma di 
      Campionato di Corsa di Quadrighe.</p>
      <p>Le prove hanno luogo con la partecipazione di un massimo di 9 carri per ogni batteria. Il rito dentro l'arena, consiste in una presentazione in 
      colonna orizzontale che possa dare un'idea della forza delle quadrighe. In un secondo momento viene dato il via alla Corsa che consiste in  sette giri 
      del circuito ovale in senso antiorario per un totale di circa 3.200 metri di lunghezza, che sono coperti in 4 minuti e mezzo.</p>
      <p>La velocità massima raggiunta da ogni carro è di circa 60km/h. I carri sono attualmente realizzati in alluminio, in modo da essere leggeri e resistenti, 
      offrendo sempre sicurezza per la pratica dello sport, sia per i cavalli che per i piloti. Le imbracature e le briglie che usiamo oggi, sono stati copiati
      integralmente  dall\`epico Ben Hur, film prodotto grazie ad un\`enorme ricerca storica. </p>
      <p>Le suole per la trazione devono essere rinforzate con trame di nylon. Nulla impedisce che le imbracature siano fabbricate con altro tipo di materiale.
      Oggi, con l\`attuale disponibilità di materiali, ci aspettiamo diverse soluzioni in termini di imbracature.</p>
      <p>Le redini possono essere in cuoio o in tessuto, rivestito in pelle di vacchetta all'altezza degli anelli.</p>
      <p><strong>Procedure di sicurezza:</strong></p>
      <p>Esistono poche, ma fondamentali regole di sicurezza. Se soddisfatte, possiamo garantire la loro efficacia. Fra queste:</p>
      <p>1. Nessun pilota deve correre esattamente dietro al pilota di fronte, troppo vicino al suo carro, nella stessa traiettoria.</p>
      <p>2. I piloti devono guardare indietro almeno due volte in ogni tratto dritto della pista ovale, all'inizio e alla fine di ciascuno. 
      Guardando indietro, puó assicurarsi della posizione degli altri carri in relazione alla sua. Nel caso un carro stia correndo dietro al suo, 
      molto vicino durante il tratto dritto e il carro dietro non riesca ad ottenere l'allineamento del posteriore, il pilota davanti dovrá fare 
      spazio poiché il carro dietro potrebbe avere un problema.</p>
      <p>É inoltre importante, durante l\`ingresso in curva, dare la precedenza a quello a cui realmente spetta.</p>
      `,
    },

    equipamentos: {
      titulo: 'Attrezzature',
      itens: [
        {
          titulo: 'Lombilho',
          img: 'lombilho',
          texto: `Permette la frenata della vettura. Con due (02) maniglie laterali che sostengono la pianta dei trazione (supporto di frenata si verifica in sernelha).`,
        },
        {
          titulo: 'Peiteira',
          img: 'peiteira',
          texto: `Sostenere il petto e il collo della stampa animale di forza.`,
        },
        {
          titulo: 'Pigtail peiteira',
          img: 'rabicho',
          texto: `Accessori di collegamento per peiteira lombilho. Trasmettere forza frenante a lombilho.`,
        },
        {
          titulo: 'Filetto',
          img: 'bridao',
          texto: `E la bocca dell'animale.`,
        },
        {
          titulo: 'Halter',
          img: 'cabecada',
          texto: `Supporto briglie e redini sulla testa dell'animale.`,
        },
        {
          titulo: 'Pinch trazione',
          img: 'mangote',
          texto: `Solas rinforzati fibbie preda su bobine fissati nel bagagliaio di ottenere trazione suole peiteira.`,
        },
        {
          titulo: 'Guinzaglio petto',
          img: 'trela',
          texto: `Accessorio (corrente) con 02 (due) zanzare (01 a ciascuna estremità) utilizzato per contenere l'animale dall'anello peiteira all'anello rotante della punta della lancia.`,
        },
        {
          titulo: 'Redini',
          img: 'redea',
          texto: `Accessorio collegato a briglie venire nelle mani del pilota. Usato per guidare l'animale.`,
        },
        {
          titulo: 'Guinzaglio parola di bocca',
          img: 'trelab',
          texto: `Limita la distanza che i cavalli hanno tra loro. E depredare briglie`,
        },
        {
          titulo: 'Sola-regolazione peiteira',
          img: 'sola',
          texto: `Accessori con fori in due (02) estremità. Serve per regolare l'animale peiteira`,
        },
      ],
    },
    aarena: {
      titulo: 'L`Arena',
      texto: `<p>L'arena per la pratica della Corsa delle Quadrighe ha una spina centrale con 205 metri di lunghezza e 
      6 metri di larghezza. La pista da corsa di tutto il percorso è di 50 metri di larghezza.</p>
      <p>Queste dimensioni provengono da un libro su Roma, dove abbiamo appreso che anticamente erano adottate diverse misure per la pratica di 
      questo sport. Crediamo che queste siano le dimensioni minori permesse. Una curiosità: il Circo Massimo, nel cuore di Roma, ha una spina centrale superiore a 300 metri.</p>
      <p>L'arena è progettata in questo modo poiché é specifica per questo tipo di attacco. Come é basato sulla velocitá, i tratti dritti sono usati
      per accelerare e le curve sono necessarie per contenere la velocità.</p>
      <p>Nelle piste, come procedura di sicurezza, le estremitá dell\`arena (parte esterna delle curve) sono protette con materiale rinforzato per garantire che, 
      in caso di scontro di un carro sulla recinzione che delimita l'arena, il carro non fuoriesca dal percorso, e che sia fornita protezione e sicurezza ai piloti, ai cavalli e agli spettatori.</p>
      `,
    },
    osatletas: {
      titulo: 'Gli Atleti',
      texto: `<p>Più di 25 persone hanno giá effettuato il training e sono in grado di praticare lo sport in modo sicuro e di 
      insegnare questo sport ad altre persone. Offriamo struttura completa per il training di nuovi piloti.</p>
      <p>Quanti piú appassionati di questo sport, tanto più rapida sará la popolarizzazione della Corsa delle Quadrighe. </p>
      `,
    },
    osanimais: {
      titulo: 'Gli animali',
      texto: `
      <p>Attualmente abbiamo 44 cavalli per la pratica di questo sport.</p>
      <p>Tutti questi animali ricevono un trattamento specifico per animali da corsa.</p>
      <p>Ferratura ogni 30 giorni, preparazione della criniera e della coda, dieta integrata con supplementi alimentari con orientazione di nutrizionisti 
      per cavalli in fase di esercizio pesante. Viene inoltre effettuato il controllo dei parassiti.</p>
      <p>La routine di allenamento è di tre volte a settimana, 30 minuti. Esercizi di manovra e di forza che li prepara per la corsa.</p>`,
    },
    fotos: {
      titulo: 'Galleria di Immagini',
    },

    contato: {
      titulo: 'Contatto',
      localizacao: `Posizione`,
    },
  },
  {
    menu: {
      inicio: 'Comenzar',
      tradicao: 'La Tradición',
      oesporte: 'El Deporte',
      equipamentos: 'Equipo',
      aarena: 'La Arena',
      osatletas: 'Los Atletas ',
      osanimais: 'Los Animales',
      fotos: 'Imágenes',
      localizacao: 'Dirección',
      contato: 'Contacto',
      imprensa: 'Prensa',
    },
    titulo: 'Carreras de Cuadrigas',
    frase:
      'Un deporte milenario que se extinguió en el Siglo IV d.C y resurge como deporte por primera vez en la Hacienda Estrela D’Oeste en Cravinhos, interior de São Paulo. Disfruta este maravilloso deporte, su seguridad y su tradición.',
    pdf: `Las cuadrigas en Arenas Brasileñas`,
    linkPdf: `Haga clic para leer`,
    arquivo: `es_las_cuadrigas_en_arenas_brasilenas.pdf`,
    imprensa: {
      titulo: `Sala de prensa`,
      texto: 'Vea lo que ya se ha informado sobre las Quadriga Races'
    },
    tradicao: {
      titulo: 'La tradición',
      texto: `<p>La <strong>cuadriga</strong> (Latin <em>quadri</em>-, cuatro, y <em>jungere</em>, yuntas) es una carro o carroza tirado por 
      cuatro caballos en línea.</p>
      <p>La cuadriga fue inventada por los asirios que rápidamente la transformaron en carros de guerra.</p>
      <p>A través de los tiempos fueran asimiladas por otros pueblos e incorporadas a sus ejércitos.</p>
      <p>Los romanos popularizaron las Corridas de Cuadrigas como deporte. La cuadriga fue adoptada en la Antigua 
      Roma en las carreras de carruajes, habiendo sido el Circo Máximos de Roma escenario de muchas de ellas. </p>
      <p>En esta época, al revés de lo que sucede hoy, poco se preocupaba con la integridad física de los participantes.</p>
      <p>Sus carreras reunían multitudes de espectadores y eran vistas por todas las clases sociales, desde la plebe hasta el Emperador. </p>
      <p>La Carrera de Cuadriga Romana tuvo su extinción en el año 400 d.C.</p>`,
    },

    oesporte: {
      titulo: 'El deporte',
      texto: `
      <p>La Carrera de Cuadrigas practicada actualmente es igual a la que era practicada en la Antigua Roma pero, 
      buscándose el desarrollo del deporte, se valoriza, más que nada, preservar la integridad física de los participantes. </p>
      <p>Los entrenamientos son <strong>gratuitos</strong> y ofrecidos a quienes quieran practicar el deporte y se desarrollan 
      de forma gradual tanto para los caballos como para los jinetes principiantes.  Son necesarias 3 sesiones por semana con una 
      duración de 30 minutos cada sesión, por un período de 4 meses. Desde el primer momento el principiante trabaja con las riendas 
      en manos y un jinete experto al lado para darle orientación y seguridad. Tanto los caballos como los jinetes necesitan como mínimo 
      3 sesiones a la semana y en los entrenamientos los caballos utilizan solamente 30% de su fuerza.</p>
      <p>La Carrera de Cuadrigas es un deporte de los más democráticos porque pueden practicarlo personas de ambos sexos, con edad entre 
      18 hasta 70 años. La única exigencia, como en cualquier otro deporte, es la dedicación y entrenamiento. Actualmente, corremos entre
      nuestro equipo contra el reloj, pero, con el aumento de los participantes, en breve estaremos disputando este deporte en formato de 
      campeonatos de Carreras de Cuadrigas.</p>
      <p>Las pruebas son ejecutadas con hasta 9 carros en cada batería. El rito dentro de la arena consiste en una presentación en columna 
      horizontal que permite tener la noción de la fuerza de las cuadrigas. Después, se da la arrancada y se corre por 7 vueltas en el circuito 
      oval anti-horario, completando aproximadamente 3200 metros de trayecto, que son realizados en 4 minutos y medio.  </p>
      <p>La velocidad máxima alcanzada por un conjunto es de aproximadamente 60km/h. Los carros actualmente son hechos de aluminio, para que sean 
      livianos y resistentes ofreciendo siempre la seguridad para la práctica del deporte, tanto para los caballos como para los jinetes. 
      Los arreos y riendas que se utiliza actualmente fueron copiados en su integridad del épico Ben Hur, película que tuvo un gran proceso de 
      investigación histórica para su realización.</p>
      <p>Las suelas de tracción deben ser reforzadas con tramas de nylon incrustadas. Nada impide que los arreos también puedan ser hechos de otros materiales. 
      Con la disponibilidad de materia prima que existe actualmente se espera más iniciativas en lo que respecta a los arreos.</p>
      <p>Las riendas pueden ser de cuero o de tejido, revestidas en vaqueta a la altura de las argollas.</p>
      <p><strong>Procedimientos de seguridad:</strong></p>
      <p>Son pocas, pero fundamentales, las reglas de seguridad. Si se cumplen, garantizamos  su eficacia. Las reglas son:</p>
      <p>1. Ningún jinete debe correr exactamente detrás del jinete que está delante, ni demasiado cerca de su carro en la misma trayectoria</p>
      <p>2. Los jinetes deben mirar para atrás 2 veces, como mínimo, en cada recta de un circuito oval, en el inicio y cerca del final de cada una de ellas. 
      Debe mirar para atrás para certificarse la posición de los otros carros en relación al suyo. En el caso de que haya un carro corriendo detrás del suyo, 
      demasiado cerca durante la trayectoria de una recta, y si el carro de atrás no salió del alineamiento, el jinete que está delante debe quitar su carro 
      pues el que está detrás puede estar con algún problema. </p>
      <p>Es importante también dar paso para aquel que esté en las entradas de las curvas.</p>
      `,
    },

    equipamentos: {
      titulo: 'Equipo',
      itens: [
        {
          titulo: 'Lombilho',
          img: 'lombilho',
          texto: `Permite que el frenado del coche. Con dos (02) asas laterales que soportan las plantas de tracción (con soporte de frenado se produce en sernelha)`,
        },
        {
          titulo: 'Peiteira',
          img: 'peiteira',
          texto: `Apoyar el pecho y el cuello del animal print en popa.`,
        },
        {
          titulo: 'Pigtail peiteira',
          img: 'rabicho',
          texto: `Accesorios ligarse a peiteira lombilho. Transmitir fuerza de frenado a lombilho.`,
        },
        {
          titulo: 'Filete',
          img: 'bridao',
          texto: `Y la boca del animal.`,
        },
        {
          titulo: 'Halter',
          img: 'cabecada',
          texto: `Brida de apoyo y riendas en la cabeza del animal.`,
        },
        {
          titulo: 'Tracción Pinch',
          img: 'mangote',
          texto: `Reforzados hebillas Solas aprovechan de bobinas fijas en el tronco para conseguir la tracción soles peiteira.`,
        },
        {
          titulo: 'Pecho correa',
          img: 'trela',
          texto: `Accesorios (actual) con 02 (dos) Mosquitos (01 en cada extremo) que se utiliza para sujetar al animal por el peiteira anillo de la corona de giro de la punta de la lanza.`,
        },
        {
          titulo: 'Riendas',
          img: 'redea',
          texto: `Accesorios conectados los frenos entren en las manos del conductor. Se utiliza para conducir el animal.`,
        },
        {
          titulo: 'Correa de boca en boca',
          img: 'trelab',
          texto: `Limita la distancia que los caballos tienen entre sí. Y aprovecharse de frenos.`,
        },
        {
          titulo: 'Sola-regulación peiteira',
          img: 'sola',
          texto: `Accesorio con agujeros en dos (02) extremos. Sirve para ajustar el peiteira animales.`,
        },
      ],
    },
    aarena: {
      titulo: 'La Arena',
      texto: `<p>La arena para la práctica de la carrera de carros tiene 205 metros de largo y 6 metros de ancho.  
      La pista de carrera, alrededor del círculo central es de 50 metros de ancho.</p>
      <p>Esas medidas provienen de un libro sobre Roma donde aprendemos que varias medidas eran adoptadas 
      en los circos para la práctica de este deporte. Creemo que esta es menor que aquellas. Apenas a título de curiosidad, 
      El Circo Máximos en el corazón de Roma, tenía un círculo central por encima de los 300 metros</p>
      <p>La arena es concebida de esta manera por ser específica para esta categoría de enganche. 
      Como se trata de una tracción de velocidad, se utiliza las rectas para aumentar la velocidad y es necesario disminuirla en las curvas. </p>
      <p>En las pistas como procedimiento de seguridad, las cabeceras de la arena (en la parte externa de las curvas) son protegidas con material 
      reforzado para garantizar que, en caso de algún accidente o choque con la cerca delimitadora de la arena, el carruaje no salga de la misma, 
      permitiendo, al mismo tiempo, seguridad para los jinetes, los caballos y los espectadores. </p>
      
      `,
    },
    osatletas: {
      titulo: 'Los atletas',
      texto: `<p>Más de 25 personas ya han pasado por los entrenamientos y están aptos a practicar el deporte con seguridad y enseñarlo a otras personas. Ofrecemos una estructura completa para el entrenamiento de los jinetes.</p>
      <p>Cuantos más sean los adeptos al deporte, más rápido las Carreras de Cuadrigas se popularizarán.</p>
      `,
    },
    osanimais: {
      titulo: 'Los Animales',
      texto: `<p>Actualmente tenemos 44 caballos para la práctica del deporte. </p>
      <p>Todos los animales reciben un tratamiento específico para animales de carrera.</p>
      <p>Herraje cada 30 días, preparación del crin y rabo y son alimentados y reciben suplementación alimentaria con orientación 
      nutricional profesional para caballos sometidos a ejercicios pesados. También pasan por control parasitario. </p>
      <p>Su rutina de entrenamiento es de 3 veces por semana, 30 minutos. Ejercicios de maniobras y de fuerza que los preparan para las pruebas.</p>
      `,
    },
    fotos: {
      titulo: 'Galería de Imágenes',
    },

    contato: {
      titulo: 'Contacto',
      localizacao: `Dirección`,
    },
  },
];
